module.exports = __webpack_public_path__ + "static/img/200236.6ec18da0.png";